import request from "@/utils/request";
import { normalizeContractOrderPayload } from "@/utils/orderType";

// 快捷发布
export function addFastGoods(data) {
  return request({
    url: "/api/mts-api/goods/addGoods",
    method: "post",
    data: data,
  });
}

// 快捷发布商品编辑（与新增发布接口隔离）
export function updateFastGoods(data) {
  return request({
    url: "/api/mts-api/goods/change/record/updateData",
    method: "post",
    data,
  });
}
// 快捷下单
export function createOrder(data) {
  return request({
    url: "/api/mts-api/preOrder/createOrder",
    method: "post",
    data: data,
  });
}
// 商务获取用户的意向单列表
export function myOrderList(param) {
  return request({
    url: "/api/mts-api/preOrder/getOrderList",
    method: "get",
    params: param,
  });
}
// 商务获取用户的购物车列表
export function getCartOrderList(param) {
  return request({
    url: "/api/mts-api/preOrder/getCartOrderList",
    method: "get",
    params: param,
  });
}

// 确认购买意向单（生成交易合同、订单）-快捷模式
export function confirmFollowPreOrder(data) {
  return request({
    url: "/api/mts-api/order/confirmFollowPreOrderAndCreateOrder",
    method: "post",
    data: normalizeContractOrderPayload(data),
  });
}
// 交易订单中心-查看订单详情-快捷模式
export function myOrderDetail(params) {
  return request({
    url: "/api/mts-api/order/myOrderDetail",
    method: "get",
    params: params,
  });
}

/**
 *  生成采购合同页面-详情
 * @param {string} goodsCode 商品编号
 *
 */
export function getGoodsDetail({ goodsCode }) {
  return request({
    url: "/api/mts-api/goods/getGoods",
    method: "get",
    params: { goodsCode },
  });
}

/**
 * 绑定商品
 * @param {string} goodsId 商品编号
 * @returns
 */
export function bindGoods({ goodsId }) {
  return request({
    url: "/api/mts-api/goods/bindGoods",
    method: "post",
    data: { goodsId },
  });
}

// 创建采购订单-快捷模式
export function createPurchaseOrder(data) {
  return request({
    url: "/api/mts-api/order/createOrder",
    method: "post",
    data: normalizeContractOrderPayload(data),
  });
}

/**获取采购合同详情
 * @param {string} contractId 合同编号
 * @returns
 */
export function getPurchaseContractDetail({ contractId, contractType }) {
  return request({
    url: "/api/mts-api/order/getContractDetail",
    method: "get",
    params: { contractId, contractType },
  });
}

/**
 * 审核采购合同
 * @param {string} id 记录ID
 * @param {string} status 审核状态 1通过 2驳回 3撤回 4-商务复核驳回客户上传PI、 5-商务驳回客户上传PO、6-商务复核PI通过、7-商务复核PO通过
 * @param {string} remark 审核意见
 * @param {number} reviewType 审核类型 -reviewType  1 订单审核、 2 合同审核
 * @param {object} reviewFile 复核驳回的文件信息
 * @returns
 */
export function auditContract({
  id,
  status,
  remark,
  reviewType,
  fileUrlList,
  reviewFile,
}) {
  return request({
    url: "/api/mts-api/contract/review/update",
    method: "post",
    data: { id, status, remark, reviewType, fileUrlList, reviewFile },
  });
}

/**
 * 下载采购订单PO
 */
export function downloadPurchaseOrder(data) {
  return request({
    url: "/api/mts-api/invoice/download/purchaseOrder",
    method: "post",
    responseType: "blob", // 重要：设置响应类型为 blob，以便正确处理文件下载
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  });
}

/**
 * 下载形式发票PI
 */
export function downloadProformaInvoice(data) {
  return request({
    url: "/api/mts-api/invoice/download/proformaInvoice",
    method: "post",
    responseType: "blob", // 重要：设置响应类型为 blob，以便正确处理文件下载
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  });
}

/**
 * 下载发票INV
 */
export function downloadInvoice(data) {
  return request({
    url: "/api/mts-api/invoice/download/invoice",
    method: "post",
    responseType: "blob", // 重要：设置响应类型为 blob，以便正确处理文件下载
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  });
}

/**
 * 下载装箱单PL
 */
export function downloadPackingList(data) {
  return request({
    url: "/api/mts-api/invoice/download/packingList",
    method: "post",
    responseType: "blob", // 重要：设置响应类型为 blob，以便正确处理文件下载
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  });
}

/**
 * 下载销售合同
 */
export function downloadContract(data) {
  return request({
    url: "/api/mts-api/invoice/download/contract",
    method: "post",
    responseType: "blob", // 重要：设置响应类型为 blob，以便正确处理文件下载
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  });
}

/**
 * 下载送货单
 */
export function downloadDeliveryNote(data) {
  return request({
    url: "/api/mts-api/invoice/download/deliveryNote",
    method: "post",
    responseType: "blob", // 重要：设置响应类型为 blob，以便正确处理文件下载
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  });
}

/**
 * 获取合同草稿数据
 * @param {string} preOrderId 订单编号
 * @param {string} goodsCode 商品编号
 * @returns
 */
export function getContractDraft({ preOrderId, goodsCode }) {
  return request({
    url: "/api/mts-api/order/getDraftContract",
    method: "get",
    params: { preOrderId, goodsCode },
  });
}

/**
 * 保存合同草稿数据
 * @param {number} type 0表示销售流程，1表示采购流程
 */
export function createDraftOrder(data) {
  return request({
    url: "/api/mts-api/order/createDraftOrder",
    method: "post",
    data: normalizeContractOrderPayload(data),
  });
}

/**
 * 快捷模式-拆分订单
 * @param {string} goodsCode 商品编号
 * @param {number} splitCount 拆分数量
 * @param {Array} splitList 拆分数量数组
 * @returns
 */
export function splitOrder({ goodsCode, splitCount, splitList }) {
  return request({
    url: "/api/mts-api/order/split",
    method: "post",
    data: { goodsCode, splitCount, splitList },
  });
}

/**
 * 快捷模式-取消拆分订单
 * @param {string} originalGoodsId 原始商品编号
 * @param {string} goodsCode 商品编号
 * @returns
 */
export function cancelSplitOrder({ originalGoodsId, goodsCode }) {
  return request({
    url: "/api/mts-api/order/cancelSplit",
    method: "post",
    params: { originalGoodsId, goodsCode },
  });
}

/**
 * 快捷模式-新增供应商联系人
 * 
@param {string} supplierId 供应商ID 必需
@param {string} contact 联系人名称 必需
@param {string} sex 联系人性别 必需
@param {string} mobile 联系人电话 必需  
@param {string} wxNo 联系人微信号 必需
@param {Array[string]} character 联系人性格（多选 string数组）可选
@param {Array[string]} hobby 联系人爱好（多选 string数组） 可选
@param {string} jiguan 联系人籍贯 可选
@param {number} negotiatorUserId 谈判人ID 可选
 * @returns
 */
export function addContact(data) {
  return request({
    url: "/api/mts-api/supplier/addContact",
    method: "post",
    data,
  });
}

/**
 * 快捷模式-设置联系人为默认联系人
 * @param {string} supplierId 供应商ID 必需
 * @param {string} contact 联系人名称 必需
 * @param {string} mobile 联系人电话 必需
 * @returns
 */
export function setMasterContact({ supplierId, contact, mobile }) {
  return request({
    url: "/api/mts-api/supplier/selectContact",
    method: "post",
    data: { supplierId, contact, mobile },
  });
}
/**
 * 快捷模式-新增供应商地址
 * @param {string} supplierId 供应商ID 必需
 * @param {string} address 收货地址 必需
 * @param {string} name 收货人名称 可选
 * @param {string} mobile 收货电话 可选
 * @returns
 */
export function addAddress({ supplierId, address, name, mobile }) {
  return request({
    url: "/api/mts-api/supplier/addAddress",
    method: "post",
    data: { supplierId, address, name, mobile },
  });
}
/**
 * 快捷模式-设置收货地址为默认地址
 * @param {string} supplierId 供应商ID 必需
 * @param {string} entityId 收货地址的实体ID 必需
 * @returns
 */
export function setMasterAddress({ supplierId, entityId }) {
  return request({
    url: "/api/mts-api/supplier/selectAddress",
    method: "post",
    data: { supplierId, entityId },
  });
}

// 图片识别
// type  1.供应商 2.新增收货地址
export function ocrRecognize(data) {
  return request({
    url: "/api/mts-api/supplier/ocr",
    method: "post",
    data,
  });
}

// 商务获取用户的意向单列表
export function getOrderNodes(param) {
  return request({
    url: "/api/mts-api/order/getOrderNodes",
    method: "get",
    params: param,
  });
}

/**
 * 快捷模式-新增供应商银行
 * @param {string} supplierId 供应商ID 必需
 * @param {string} bankSimple 银行简称（港澳台为必填）
 * @param {string} bankName 开户银行（港澳台为英文银行名称）
 * @param {string} accountNumber 银行卡号（港澳台为银行账号）
 * @param {string} bankAddress 银行地址（港澳台为中文地址）
 * @param {string} bankAccount 中文银行名称（港澳台）
 * @param {string} swiftCode swift code（港澳台必填）
 * @param {string} bankCode bank code（港澳台必填）
 * @param {string} bankBranch 支行名称（大陆）
 * @param {string} bankBranchCode 联行号（大陆）
 * @param {string} bankAddressEn 银行英文地址
 * @returns
 */
export function addBank(data) {
  return request({
    url: "/api/mts-api/supplier/addBank",
    method: "post",
    data,
  });
}

export function getIsCreate(data) {
  return request({
    url: "/api/mts-api/preOrder/getIsCreate",
    method: "post",
    data: data,
  });
}
